import React from 'react';
import Row from 'react-bootstrap/Row';


export default function returnHeader(page, style) {
    if (page === "APPLE"){
        if (style === "TO"){
            return AppleHeaderTO
        } else {
            return AppleHeader
        }
    }else if (page === "ERROR"){
        if (style === "TO"){
            return UnknownErrorHeaderTO
        } else {
            return UnknownErrorHeader
        }
    } 
}


const AppleHeaderTO = 
<Row className = "justify-content-center message__TO left">
You're one step away from accessing your Owners account. Please provide your contact details below to sign in.
</Row>

const AppleHeader = 
<Row className = "justify-content-center message__TO left">
You're one step away from accessing your Toyota account. Please provide your contact details below to sign in.
</Row>

const UnknownErrorHeaderTO = 
<Row className = "justify-content-center text__TO">
Toyota Owners service is down and should be back on momentarily. Please try again shortly.
</Row>

const UnknownErrorHeader = 
<Row className = "justify-content-center text__TO">
Toyota service is down and should be back on momentarily. Please try again shortly.
</Row>


